export enum LocalStorage {
 INITIALIZE_INTERVIEW = "initialize_interview",
 INTERVIEW_SETUP = "interview_setup",
 TOKEN = "token",
 INTERVIEW_STATUS = "interview_status",
 IS_NEW = "is_new",
 UPDATED = "updated",
 USER = "user",
 REFRESH_TOKEN = "refreshToken",
 SELECTED_INTERVIEWER = "selected_interviewer",
 OFFLINE = "offline",
 SCORE_REPORT = "score_report",
 LOCAL_INTERVIEWD_LIST = "local_interviewed_list",
}
